export default {
    BASE_64_TABLE: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '+', '/'],
    REALM: "Blackrock",
    SIM_REFRESH_INTERVAL_IN_MS: 100,
    ROLES: ['Tank', 'Melee', 'Ranged', 'Heal'],
    COMPLETE_ROLES: ['Tank', 'Melee', 'Ranged', 'Heal', 'None'],
    STATES: ["None", "Raider", "Backup", "Bewerber", "Twink", "Member", "Gast"],
    ROSTER_LIST: ["fire", "flame"],
    ROSTER_INFO: {
        fire: {
            description: "Feuer",
            value: "fire",
            baseUrl: "https://wowaudit.com/eu/blackrock/zirkel-des-phoenix/feuer",
            color: "primary"
        },
        flame: {
            description: "Flamme",
            value: "flame",
            baseUrl: "https://wowaudit.com/eu/blackrock/zirkel-des-phoenix/flamme",
            color: "#298F85"
        }
    },
    // SEASONS: {
    //     DF4: {
    //         CREST: {
    //             0: { short: "weathered", long: "weathered undermine crests", craftingAmount: 30},
    //             1: { short: "carved",    long: "carved undermine crests", craftingAmount: null},
    //             2: { short: "runed",     long: "runed undermine crests", craftingAmount: 45},
    //             3: { short: "gilded",    long: "gilded undermine crests", craftingAmount: 90}
    //         },
    //         SPARK: { short: "spark",     long: "spark of awakening" }
    //     },
    //     WW1: {
    //         CREST: {
    //             0: { short: "weathered", long: "weathered harbringer crests", craftingAmount: 30,   craftingLevel: 577 },
    //             1: { short: "carved",    long: "carved harbringer crests",    craftingAmount: null, craftingLevel: 590 },
    //             2: { short: "runed",     long: "runed harbringer crests",     craftingAmount: 45,   craftingLevel: 606 },
    //             3: { short: "gilded",    long: "gilded harbringer crests",    craftingAmount: 60,   craftingLevel: 623 }
    //         },
    //         SPARK: { short: "spark", long: "spark of omens" },
    //         EQUIP_RANK: [
    //             { name: "adventurer", itemlevel: {1:571, 2:574, 3:577, 4:580, 5:584, 6:587, 7:590, 8:593} },
    //             { name: "veteran",    itemlevel: {1:584, 2:587, 3:590, 4:593, 5:597, 6:600, 7:603, 8:606} },
    //             { name: "champion",   itemlevel: {1:597, 2:600, 3:603, 4:606, 5:610, 6:613, 7:616, 8:619} },
    //             { name: "hero",       itemlevel: {1:610, 2:613, 3:616, 4:619, 5:623, 6:626} },
    //             { name: "myth",       itemlevel: {1:623, 2:626, 3:629, 4:632, 5:636, 6:639} },
    //         ]
    //     },
    //     WW2: {
    //         CREST: {
    //             0: { short: "weathered", long: "weathered undermine crests",  craftingAmount: 30,   craftingLevel: 1 },
    //             1: { short: "carved",    long: "carved undermine crests",     craftingAmount: null, craftingLevel: 1 },
    //             2: { short: "runed",     long: "runed undermine crests",      craftingAmount: 45,   craftingLevel: 1 },
    //             3: { short: "gilded",    long: "gilded undermine crests",     craftingAmount: 90,   craftingLevel: 1 }
    //         },
    //         SPARK: { short: "spark",     long: "spark of fortunes" },
    //         EQUIP_RANK: [
    //             { name: "adventurer", itemlevel: {1:610, 2:613, 3:616, 4:619, 5:623, 6:626, 7:629, 8:632} },
    //             { name: "veteran",    itemlevel: {1:623, 2:626, 3:629, 4:632, 5:636, 6:639, 7:642, 8:645} },
    //             { name: "champion",   itemlevel: {1:636, 2:639, 3:642, 4:645, 5:649, 6:652, 7:655, 8:658} },
    //             { name: "hero",       itemlevel: {1:649, 2:652, 3:655, 4:658, 5:662, 6:665} },
    //             { name: "myth",       itemlevel: {1:662, 2:665, 3:668, 4:671, 5:675, 6:678} },
    //         ]
    //     },
    //     WW3: {
    //         CREST: {
    //             0: { short: "weathered", long: "weathered ethereal crests",  craftingAmount: 30,   craftingLevel: 675 },
    //             1: { short: "carved",    long: "carved ethereal crests",     craftingAmount: null, craftingLevel: 691 },
    //             2: { short: "runed",     long: "runed ethereal crests",      craftingAmount: 45,   craftingLevel: 704 },
    //             3: { short: "gilded",    long: "gilded ethereal crests",     craftingAmount: 60,   craftingLevel: 720 }
    //         },
    //         SPARK: { short: "spark",     long: "spark of fortunes" },
    //         EQUIP_RANK: [
    //             { name: "adventurer", itemlevel: {1:655, 2:658, 3:662, 4:665, 5:668, 6:671, 7:675, 8:678} },
    //             { name: "veteran",    itemlevel: {1:668, 2:671, 3:675, 4:678, 5:681, 6:684, 7:688, 8:691} },
    //             { name: "champion",   itemlevel: {1:681, 2:684, 3:688, 4:691, 5:694, 6:697, 7:701, 8:704} },
    //             { name: "hero",       itemlevel: {1:694, 2:697, 3:701, 4:704, 5:707, 6:710} },
    //             { name: "myth",       itemlevel: {1:707, 2:710, 3:714, 4:717, 5:720, 6:723} },
    //         ]
    //     }
    // },
    // Crest ranks are defined per season in ITEM_LEVEL_SEASONS.crestRanks
    ITEM_LEVEL_SEASONS: {
        WW3: {
            id: 'WW3',
            //name: 'TWW - Season 3',

            crestRanks: [
                { rank: 1, key: 'weathered' },
                { rank: 2, key: 'carved' },
                { rank: 3, key: 'runed' },
                { rank: 4, key: 'gilded' }
            ],

            tracks: {
                adventurer: [655, 658, 662, 665, 668, 671, 675, 678],
                veteran:    [668, 671, 675, 678, 681, 684, 688, 691],
                champion:   [681, 684, 688, 691, 694, 697, 701, 704],
                hero:       [694, 697, 701, 704, 707, 710],
                myth:       [707, 710, 714, 717, 720, 723]
            },

            crestCostsByIlvl: {},

            craftingRanks: [
                { rank: 1, key: 'weathered_no_spark', range: [655, 658, 662, 665, 668], crest_info: { crest: 1, amount: 30 } },
                { rank: 2, key: 'spark',              range: [678, 681, 684, 687, 691], crest_info: null },
                { rank: 3, key: 'spark_runed',        range: [691, 694, 697, 701, 704], crest_info: { crest: 3, amount: 45 } },
                { rank: 4, key: 'spark_gilded',       range: [707, 710, 714, 717, 720], crest_info: { crest: 4, amount: 60 } }
            ],

            dungeonTable: [
                { level: 'Normal',    loot: 639, vault: null, crestReward: null },
                { level: 'Heroic',    loot: 665, vault: 678,  crestReward: [{ crest: 1, amount: 10 }] },
                { level: 'Mythic',    loot: 681, vault: 691,  crestReward: [{ crest: 2, amount: 15 }] },
                { level: 'M+ 2',      loot: 684, vault: 694,  crestReward: [{ crest: 3, amount: 10 }] },
                { level: 'M+ 3',      loot: 684, vault: 694,  crestReward: [{ crest: 3, amount: 12 }] },
                { level: 'M+ 4',      loot: 688, vault: 697,  crestReward: [{ crest: 3, amount: 14 }] },
                { level: 'M+ 5',      loot: 691, vault: 697,  crestReward: [{ crest: 3, amount: 16 }] },
                { level: 'M+ 6',      loot: 694, vault: 701,  crestReward: [{ crest: 3, amount: 18 }] },
                { level: 'M+ 7',      loot: 694, vault: 704,  crestReward: [{ crest: 4, amount: 10 }] },
                { level: 'M+ 8',      loot: 697, vault: 704,  crestReward: [{ crest: 4, amount: 12 }] },
                { level: 'M+ 9',      loot: 697, vault: 704,  crestReward: [{ crest: 4, amount: 14 }] },
                { level: 'M+ 10',     loot: 701, vault: 707,  crestReward: [{ crest: 4, amount: 16 }] },
                { level: 'M+ 11',     loot: 701, vault: 707,  crestReward: [{ crest: 4, amount: 18 }] },
                { level: 'M+ 12',     loot: 701, vault: 707,  crestReward: [{ crest: 4, amount: 20 }] },
            ],

            delveTable: [
                { tier: 1,  loot: 655, map: 668, vault: 655, lootCrests: [{ crest: 1, amount: 2 }], stashCrests: null, nemesisCrests: null },
                { tier: 2,  loot: 658, map: 671, vault: 668, lootCrests: [{ crest: 1, amount: 3 }], stashCrests: null, nemesisCrests: null },
                { tier: 3,  loot: 662, map: 678, vault: 671, lootCrests: [{ crest: 1, amount: 4 }], stashCrests: null, nemesisCrests: null },
                { tier: 4,  loot: 665, map: 671, vault: 681, lootCrests: [{ crest: 1, amount: 5 }], stashCrests: [{ crest: 2, amount: 4 }], nemesisCrests: null },
                { tier: 5,  loot: 668, map: 678, vault: 688, lootCrests: [{ crest: 1, amount: 6 }], stashCrests: [{ crest: 2, amount: 10 }], nemesisCrests: null },
                { tier: 6,  loot: 671, map: 684, vault: 691, lootCrests: [{ crest: 2, amount: 3 }], stashCrests: [{ crest: 3, amount: 5 }], nemesisCrests: null },
                { tier: 7,  loot: 681, map: 691, vault: 691, lootCrests: [{ crest: 2, amount: 5 }], stashCrests: [{ crest: 3, amount: 10 }], nemesisCrests: null },
                { tier: 8,  loot: 684, map: 694, vault: 694, lootCrests: [{ crest: 3, amount: 2 }, { crest: 4, amount: 3}], stashCrests: [{ crest: 4, amount: 4 }], nemesisCrests: null },
                { tier: 9,  loot: 684, map: 694, vault: 694, lootCrests: [{ crest: 3, amount: 4 }, { crest: 4, amount: 3}], stashCrests: [{ crest: 4, amount: 6 }], nemesisCrests: null },
                { tier: 10, loot: 684, map: 694, vault: 694, lootCrests: [{ crest: 3, amount: 6 }, { crest: 4, amount: 3}], stashCrests: [{ crest: 4, amount: 8 }], nemesisCrests: null },
                { tier: 11, loot: 684, map: 694, vault: 694, lootCrests: [{ crest: 3, amount: 8 }, { crest: 4, amount: 7}], stashCrests: [{ crest: 4, amount: 10 }], nemesisCrests: null }
            ],

            raidTable: [
                { difficulty: 'lfr',     range: [668, 671, 675, 678, 681, 684, 688, 691] },
                { difficulty: 'normal',  range: [681, 684, 688, 691, 694, 697, 701, 704] },
                { difficulty: 'heroic',  range: [694, 697, 701, 704, 707, 710] },
                { difficulty: 'mythic',  range: [707, 710, 714, 717, 720, 723] },
            ],
        },
        MD1: {
            id: 'MD1',
            name: 'Midnight - Season 1',

            crestRanks: [
                { rank: 1, key: 'adventurer_dawncrest' },
                { rank: 2, key: 'veteran_dawncrest' },
                { rank: 3, key: 'champion_dawncrest' },
                { rank: 4, key: 'hero_dawncrest' },
                { rank: 5, key: 'myth_dawncrest' }
            ],

            tracks: {
                adventurer: [220, 224, 227, 230, 233, 237],
                veteran:    [233, 237, 240, 243, 246, 250],
                champion:   [246, 250, 253, 256, 259, 263],
                hero:       [259, 263, 266, 269, 272, 276],
                myth:       [272, 276, 279, 282, 285, 289]
            },

            crestCostsByIlvl: {
                224: [{ crest: 1, amount: 20 }],
                227: [{ crest: 1, amount: 20 }],
                230: [{ crest: 1, amount: 20 }],
                233: [{ crest: 1, amount: 20 }],
                237: [{ crest: 1, amount: 20 }, { crest: 2, amount: 20 }],

                240: [{ crest: 2, amount: 20 }],
                243: [{ crest: 2, amount: 20 }],
                246: [{ crest: 2, amount: 20 }],
                250: [{ crest: 2, amount: 20 }, { crest: 3, amount: 20 }],

                253: [{ crest: 3, amount: 20 }],
                256: [{ crest: 3, amount: 20 }],
                259: [{ crest: 3, amount: 20 }],

                263: [{ crest: 3, amount: 20 }, { crest: 4, amount: 20 }],
                266: [{ crest: 4, amount: 20 }],
                269: [{ crest: 4, amount: 20 }],
                272: [{ crest: 4, amount: 20 }],

                276: [{ crest: 4, amount: 20 }, { crest: 5, amount: 20 }],
                279: [{ crest: 5, amount: 20 }],
                282: [{ crest: 5, amount: 20 }],
                285: [{ crest: 5, amount: 20 }],
                289: [{ crest: 5, amount: 20 }]
            },

            craftingRanks: [
                { rank: 1, key: 'adventurer', range: [220, 224, 227, 230, 233], crest_info: { crest: 1, amount: 80 } },
                { rank: 2, key: 'veteran',    range: [233, 237, 240, 243, 246], crest_info: { crest: 2, amount: 80 } },
                { rank: 3, key: 'spark',   range: [246, 250, 253, 256, 259], crest_info: null },
                { rank: 4, key: 'spark_hero',       range: [259, 263, 266, 269, 272], crest_info: { crest: 4, amount: 80 } },
                { rank: 5, key: 'spark_myth',       range: [272, 276, 279, 282, 285], crest_info: { crest: 5, amount: 80 } }
            ],

            dungeonTable: [
                { level: 'Normal',  loot: 214, vault: null, crestReward: null },
                { level: "Heroic",  loot: 230, vault: 243, crestReward: [{ crest: 2, amount: 0 }] },
                //{ level: "Mythic (Pre Season)",  loot: 240, vault: 256, crestReward: [{ crest: 2, amount: 0 }] },
                { level: "Mythic",  loot: 246, vault: 256, crestReward: [{ crest: 3, amount: 10 }] },
                { level: "M+ 2",    loot: 250, vault: 259, crestReward: [{ crest: 3, amount: 12 }] },
                { level: "M+ 3",    loot: 250, vault: 259, crestReward: [{ crest: 3, amount: 14 }] },
                { level: "M+ 4",    loot: 253, vault: 263, crestReward: [{ crest: 4, amount: 10 }] },
                { level: "M+ 5",    loot: 256, vault: 263, crestReward: [{ crest: 4, amount: 12 }] },
                { level: "M+ 6",    loot: 259, vault: 266, crestReward: [{ crest: 4, amount: 14 }] },
                { level: "M+ 7",    loot: 259, vault: 269, crestReward: [{ crest: 4, amount: 16 }] },
                { level: "M+ 8",    loot: 263, vault: 269, crestReward: [{ crest: 4, amount: 18 }] },
                { level: "M+ 9",    loot: 263, vault: 269, crestReward: [{ crest: 5, amount: 10 }] },
                { level: "M+ 10",   loot: 266, vault: 272, crestReward: [{ crest: 5, amount: 12 }] },
                { level: "M+ 11",   loot: 266, vault: 272, crestReward: [{ crest: 5, amount: 14 }] },
                { level: "M+ 12",   loot: 266, vault: 272, crestReward: [{ crest: 5, amount: 16 }] }
            ],

            delveTable: [
                { tier: 1,  loot: 220, map: null, vault: 233, lootCrests: null, stashCrests: null, nemesisCrests: null },
                { tier: 2,  loot: 224, map: null, vault: 237, lootCrests: null, stashCrests: null, nemesisCrests: null },
                { tier: 3,  loot: 227, map: null, vault: 240, lootCrests: null, stashCrests: null, nemesisCrests: null },
                { tier: 4,  loot: 230, map: 237, vault: 243,  lootCrests: [{ crest: 1, amount: 0 }],  stashCrests: null,  nemesisCrests: null },
                { tier: 5,  loot: 233, map: 243, vault: 246,  lootCrests: [{ crest: 2, amount: 0 }],  stashCrests: null,  nemesisCrests: null },
                { tier: 6,  loot: 237, map: 250, vault: 253,  lootCrests: [{ crest: 2, amount: 0 }],  stashCrests: null,  nemesisCrests: null },
                { tier: 7,  loot: 246, map: 256, vault: 256,  lootCrests: [{ crest: 3, amount: 4 }],  stashCrests: null,  nemesisCrests: null },
                { tier: 8,  loot: 250, map: 259, vault: 259,  lootCrests: [{ crest: 3, amount: 6 }],  stashCrests: null,  nemesisCrests: [{ crest: 3, amount: 5 }] },
                { tier: 9,  loot: 250, map: 259, vault: 259,  lootCrests: [{ crest: 3, amount: 8 }],  stashCrests: null,  nemesisCrests: [{ crest: 3, amount: 5 }] },
                { tier: 10, loot: 250, map: 259, vault: 259,  lootCrests: [{ crest: 3, amount: 10 }], stashCrests: null,  nemesisCrests: [{ crest: 4, amount: 5 }] },
                { tier: 11, loot: 250, map: 259, vault: 259,  lootCrests: [{ crest: 4, amount: 15 }], stashCrests: [{ crest: 5, amount: 5 }], nemesisCrests: [{ crest: 4, amount: 5 }] }
            ],

            raidTable: [
                { difficulty: 'lfr',     range: [233, 237, 240, 243] },
                { difficulty: 'normal',  range: [246, 250, 253, 256] },
                { difficulty: 'heroic',  range: [259, 263, 266, 269] },
                { difficulty: 'mythic',  range: [272, 276, 279, 282] },
            ],
        },
        MD2: {
            id: 'MD2',
            name: 'Midnight - Season 2',

            crestRanks: [
                { rank: 1, key: 'adventurer_mistcrest' },
                { rank: 2, key: 'veteran_mistcrest' },
                { rank: 3, key: 'champion_mistcrest' },
                { rank: 4, key: 'hero_mistcrest' },
                { rank: 5, key: 'myth_mistcrest' }
            ],

            tracks: {
                adventurer: [266, 269, 272, 276, 279, 282],
                veteran:    [279, 282, 285, 289, 292, 295],
                champion:   [292, 295, 298, 302, 305, 308],
                hero:       [305, 308, 311, 315, 318, 321],
                myth:       [318, 321, 324, 328, 331, 334, 337, 341, 344]
            },

            crestCostsByIlvl: {
                269: [{ crest: 1, amount: 20 }],
                272: [{ crest: 1, amount: 20 }],
                276: [{ crest: 1, amount: 20 }],
                279: [{ crest: 1, amount: 20 }],
                282: [{ crest: 1, amount: 20 }, { crest: 2, amount: 20 }],

                285: [{ crest: 2, amount: 20 }],
                289: [{ crest: 2, amount: 20 }],
                292: [{ crest: 2, amount: 20 }],
                295: [{ crest: 2, amount: 20 }, { crest: 3, amount: 20 }],

                298: [{ crest: 3, amount: 20 }],
                302: [{ crest: 3, amount: 20 }],
                305: [{ crest: 3, amount: 20 }],

                308: [{ crest: 3, amount: 20 }, { crest: 4, amount: 20 }],
                311: [{ crest: 4, amount: 20 }],
                315: [{ crest: 4, amount: 20 }],
                318: [{ crest: 4, amount: 20 }],

                321: [{ crest: 4, amount: 20 }, { crest: 5, amount: 20 }],
                324: [{ crest: 5, amount: 20 }],
                328: [{ crest: 5, amount: 20 }],
                331: [{ crest: 5, amount: 20 }],
                334: [{ crest: 5, amount: 20 }]
            },

            craftingRanks: [
                {
                    rank: 1,
                    key: 'adventurer',
                    range: [266, 269, 272, 276, 279],
                    crest_info: { crest: 1, amount: 80 }
                },
                {
                    rank: 2,
                    key: 'veteran',
                    range: [279, 282, 285, 289, 292],
                    crest_info: { crest: 2, amount: 80 }
                },
                {
                    rank: 3,
                    key: 'spark',
                    range: [292, 295, 298, 302, 305],
                    crest_info: null
                },
                {
                    rank: 4,
                    key: 'spark_hero',
                    range: [305, 308, 311, 315, 318],
                    crest_info: { crest: 4, amount: 80 }
                },
                {
                    rank: 5,
                    key: 'spark_myth',
                    range: [318, 321, 324, 328, 331],
                    crest_info: { crest: 5, amount: 80 }
                }
            ],

            dungeonTable: [
                { level: 'Normal',  loot: 259, vault: null, crestReward: null },
                { level: 'Heroic',  loot: 276, vault: 289, crestReward: [{ crest: 2, amount: 0 }] },

                { level: 'Mythic',  loot: 292, vault: 302, crestReward: [{ crest: 3, amount: 10 }] },

                { level: 'M+ 2',    loot: 295, vault: 305, crestReward: [{ crest: 3, amount: 12 }] },
                { level: 'M+ 3',    loot: 295, vault: 305, crestReward: [{ crest: 3, amount: 14 }] },

                { level: 'M+ 4',    loot: 298, vault: 308, crestReward: [{ crest: 4, amount: 10 }] },
                { level: 'M+ 5',    loot: 302, vault: 308, crestReward: [{ crest: 4, amount: 12 }] },
                { level: 'M+ 6',    loot: 305, vault: 311, crestReward: [{ crest: 4, amount: 14 }] },
                { level: 'M+ 7',    loot: 305, vault: 315, crestReward: [{ crest: 4, amount: 16 }] },
                { level: 'M+ 8',    loot: 308, vault: 315, crestReward: [{ crest: 4, amount: 18 }] },

                { level: 'M+ 9',    loot: 308, vault: 315, crestReward: [{ crest: 5, amount: 10 }] },
                { level: 'M+ 10',   loot: 311, vault: 318, crestReward: [{ crest: 5, amount: 12 }] },
                { level: 'M+ 11',   loot: 311, vault: 318, crestReward: [{ crest: 5, amount: 14 }] },
                { level: 'M+ 12',   loot: 311, vault: 318, crestReward: [{ crest: 5, amount: 16 }] }
            ],

            delveTable: [
                {
                    tier: 1,
                    loot: 266,
                    map: null,
                    vault: 279,
                    lootCrests: null,
                    stashCrests: null,
                    nemesisCrests: null
                },
                {
                    tier: 2,
                    loot: 269,
                    map: null,
                    vault: 282,
                    lootCrests: null,
                    stashCrests: null,
                    nemesisCrests: null
                },
                {
                    tier: 3,
                    loot: 272,
                    map: null,
                    vault: 285,
                    lootCrests: null,
                    stashCrests: null,
                    nemesisCrests: null
                },
                {
                    tier: 4,
                    loot: 276,
                    map: 282,
                    vault: 289,
                    lootCrests: [{ crest: 1, amount: 0 }],
                    stashCrests: null,
                    nemesisCrests: null
                },
                {
                    tier: 5,
                    loot: 279,
                    map: 289,
                    vault: 292,
                    lootCrests: [{ crest: 2, amount: 0 }],
                    stashCrests: null,
                    nemesisCrests: null
                },
                {
                    tier: 6,
                    loot: 282,
                    map: 292,
                    vault: 298,
                    lootCrests: [{ crest: 2, amount: 0 }],
                    stashCrests: null,
                    nemesisCrests: null
                },
                {
                    tier: 7,
                    loot: 292,
                    map: 295,
                    vault: 302,
                    lootCrests: [{ crest: 3, amount: 4 }],
                    stashCrests: null,
                    nemesisCrests: null
                },
                {
                    tier: 8,
                    loot: 295,
                    map: 305,
                    vault: 305,
                    lootCrests: [{ crest: 3, amount: 6 }],
                    stashCrests: null,
                    nemesisCrests: [{ crest: 3, amount: 5 }]
                },
                {
                    tier: 9,
                    loot: 295,
                    map: 305,
                    vault: 305,
                    lootCrests: [{ crest: 3, amount: 8 }],
                    stashCrests: null,
                    nemesisCrests: [{ crest: 3, amount: 5 }]
                },
                {
                    tier: 10,
                    loot: 295,
                    map: 305,
                    vault: 305,
                    lootCrests: [{ crest: 3, amount: 10 }],
                    stashCrests: null,
                    nemesisCrests: [{ crest: 4, amount: 5 }]
                },
                {
                    tier: 11,
                    loot: 295,
                    map: 305,
                    vault: 305,
                    lootCrests: [{ crest: 4, amount: 15 }],
                    stashCrests: [{ crest: 5, amount: 5 }],
                    nemesisCrests: [{ crest: 4, amount: 5 }]
                }
            ],

            raidTable: [
                { difficulty: 'lfr',     range: [279, 282, 285, 289] },
                { difficulty: 'normal',  range: [292, 295, 298, 302] },
                { difficulty: 'heroic',  range: [305, 308, 311, 315] },
                { difficulty: 'mythic-low',  range: [318, 321, 324, 328] },
                { difficulty: 'mythic-high',  range: [344] },
            ]
        }
    }
};